// @ts-ignore
import * as ZAFClient from 'zendesk_app_framework_sdk';
import { isIframe } from '@utils/iframe';
import logger from './logger';

logger.debug(`ZAFClient: is in iframe: ${isIframe}`);

const initZAFClient = () => {
  let client = null;

  try {
    logger.debug('ZAFClient: initialization attempt');
    client = ZAFClient.init();
    if (client) {
      logger.debug('ZAFClient: initialised successfully!');
      setupZAFClient(client);

      return client;
    }
    throw new Error('ZAFClient initialization returned null or undefined');
  } catch (error) {
    logger.warn(`ZAFClient: initialization failed: ${error}`);

    return null;
  }
};

const setupZAFClient = (client: any) => {
  client
    .get('currentUser')
    .then((data: any) => {
      logger.debug('currentUser', data);
    })
    .catch(() => {
      logger.debug('ZAFClient: path "currentUser" not found');
    });
  try {
    client.invoke('resize', { width: '100%', height: '800px' });
  } catch (e) {
    logger.warn('ZAFClient:resize failed', e);
  }
  client.on('app.activated', () => {
    logger.debug('ZAFClient:app.activated - setting size');
    client.invoke('resize', { width: '100%', height: '800px' });
  });
  client
    .context()
    .then((context: any) => {
      logger.debug('ZAFClient:context', context);
    })
    .catch(() => {
      logger.debug('ZAFClient: path "context" not found');
    });
  client
    .get('ticket')
    .then((data: any) => {
      logger.debug('ZAFClient:ticket', data);
    })
    .catch(() => {
      logger.debug('ZAFClient: path "ticket" not found');
    });
  client
    .get('ticket.requester')
    .then((data: any) => {
      logger.debug('ZAFClient:ticket.requester', data);
    })
    .catch(() => {
      logger.debug('ZAFClient: path "ticket.requester" not found');
    });
  client
    .get('contact')
    .then((data: any) => {
      logger.debug('ZAFClient:contact', data);
    })
    .catch(() => {
      logger.debug('ZAFClient: path "contact" not found');
    });
};

const zafClient = initZAFClient();

export { zafClient };
